import { useRef, useState } from 'react';

import { DialogContent } from '@mui/material';
import { pdfjs } from 'react-pdf';

import ControlPanel from './ControlPanel';
import { PDFDoc } from './PDFDocument';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

export type PDFReaderProps = {
    pdfFile: File;
    fileURL: string;
};

const PDFReader: React.FC<PDFReaderProps> = ({ pdfFile, fileURL }) => {
    const [scale, setScale] = useState(1.0);
    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const printRef = useRef(null);

    return (
        <>
            <ControlPanel
                scale={scale}
                setScale={setScale}
                numPages={numPages}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                file={pdfFile}
                fileURL={fileURL}
                printRef={printRef}
            />
            <DialogContent
                sx={{
                    padding: '0px',
                    margin: '0px !important',
                    backgroundColor: '#535659',
                    '.react-pdf__Page': {
                        backgroundColor: 'transparent !important',
                        display: 'flex',
                        justifyContent: 'center',
                    },
                }}
            >
                <PDFDoc
                    onDocumentLoadSuccess={onDocumentLoadSuccess}
                    pageNumber={pageNumber}
                    scale={scale}
                    fileURL={fileURL}
                />
            </DialogContent>
        </>
    );
};

export default PDFReader;
